import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import {catchError, map, switchMap} from 'rxjs/operators';
import {debug} from '../../../rxjs-operators';
import {error} from '../actions/toasts';
import {ArrayResponse} from '../models/array-response';
import {SendBackResult} from '../models/send-back-result';
import {BaseEffect} from './base.effect';

import {ContractLinkServiceService} from '../services/contract-link.service';
import {ContractLinkSummaries} from '../models/contract-link';
import {linkContractActionTypes, LoadLinkContractAction, LoadLinkContractFailAction, LoadLinkContractSuccessAction} from '../actions/contract-link';
import {L10nTranslationService} from 'angular-l10n';

@Injectable()
export class ContractLinkEffect extends BaseEffect {

  load$ = createEffect(() => { return this.actions$.pipe(
    ofType(linkContractActionTypes.LOAD),
    debug('Load contracts action received.'),

    map((action: LoadLinkContractAction) => Object.assign({}, action.payload , { $page: 1, $length: -1 , active: true , $orderBy: 'name' })),
    switchMap((filterD) =>  this.contractLinkServiceService.loadContract(filterD).pipe(
      map((result: SendBackResult<ArrayResponse<ContractLinkSummaries>>) => new LoadLinkContractSuccessAction(result.data.array)),
      catchError(res => this.catchResponseError(res)),
    )))
  });


  loadFail$ = createEffect(() => { return this.actions$.pipe(
    ofType(linkContractActionTypes.LOAD_FAIL),
    debug('A server error occurred while retrieving contracts list.'),
    map((action: LoadLinkContractFailAction) =>
      error(this.translation.translate('CONTRACT_LOAD_ERROR') + '  ' + action.payload, this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private contractLinkServiceService: ContractLinkServiceService,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadLinkContractFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadLinkContractFailAction(response['error'].message);
  }
}
